import(/* webpackMode: "eager" */ "/Users/chadlinmaalgraaff/Desktop/Skywalk/Pattern/pattern-dashboard/src/app/page.tsx");
